export default "__VITE_ASSET__ClCaxI2b__"